import { PorQueEstePrecio } from './por-que-este-precio';
import { desdeFilaSimulada, ID_BORRADOR } from '../lib/recorrido-del-precio';
import type { ConteosDeLaPrueba } from '../lib/lectura-del-precio';
import type { FilaSimulada } from '../types/pricing-rules.types';

/**
 * La explicación de UN producto de una `FilaSimulada`: la foto (Cómo está cada
 * producto), «Qué cambiaría» de Nueva regla y «¿Y si…?» (ver cuáles, y el
 * producto abierto). Desde el spec 225 es la explicación única
 * (`PorQueEstePrecio`); acá sólo se dice si hay una regla en prueba.
 */

/** Vive en `lib/recorrido-del-precio.ts`; se re-exporta para quien ya la importa de acá. */
export { ID_BORRADOR };

export function DesgloseSimulado({
  fila,
  etiquetaBorrador,
  idBorrador = ID_BORRADOR,
  costo,
  alcancePorRegla = {},
  conteos = null,
}: {
  fila: FilaSimulada;
  /**
   * Cómo se llama la regla nueva: «esta regla» en Nueva regla, «la que probás» en
   * «¿Y si…?». Sin ella es la foto de hoy (Cómo está cada producto): sin regla nueva.
   */
  etiquetaBorrador?: string;
  /** El id con que la regla en prueba viene en `rangos`: el de la regla que se edita, o `ID_BORRADOR`. */
  idBorrador?: string;
  /** El costo, si la pantalla lo trae aparte (la foto). Sin él, el de la fila. */
  costo?: number | null;
  /** El alcance al lado del nombre de cada regla, en la cuenta. */
  alcancePorRegla?: Record<string, string>;
  /** «¿Y si…?» y Nueva regla: cuántos productos afecta la regla, para el título. */
  conteos?: ConteosDeLaPrueba | null;
}) {
  const conBorrador = etiquetaBorrador != null;
  return (
    <div data-testid="desglose-simulado">
      <PorQueEstePrecio
        tiempo="HOY"
        recorrido={desdeFilaSimulada(fila, {
          borrador: conBorrador ? { etiqueta: etiquetaBorrador, id: idBorrador } : null,
          costo,
        })}
        alcancePorRegla={alcancePorRegla}
        conteos={conBorrador ? conteos : null}
      />
    </div>
  );
}
